/**
 * Energreen Theme Overrides
 * Atlas palette with Energreen Mobility branding
 */

import type { ClientThemeOverrides } from '../utils/themeAugmentation';
import logo from '../../../themes/energreen/energreen.png';

export const energreenThemeOverrides: ClientThemeOverrides = {
  clientId: 'energreen',
  logo,
  clientName: 'Energreen Mobility',
  hideHeaderClientName: true,
  headerLogo: {
    width: { xs: 154, sm: 220 },
    height: { xs: 28, sm: 40 },
  },
  palette: {
    light: {
      // Uses Atlas colors from semanticColors
    },
  },
};
